
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12159',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12159",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "dashboard-client-types": "static-1.367",
  "data-fetching-client": "static-1.9647",
  "foundations-components": "static-1.7882",
  "foundations-components-legacy": "static-1.907",
  "foundations-theming": "static-1.4394",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7989",
  "hub-http-shared-msw-handlers": "static-1.9898",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11443",
  "I18n": "static-7.1617",
  "jasmine-runner": "static-1.6442",
  "marketplace-storefront-base": "static-1.12220",
  "quartz": "static-1-hqd-quartz-routing-v2.22",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "reactive-variable-buffer-atom": "static-1.2834",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "settings-ui-lib": "static-1.12496",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7084",
  "ui-addon-i18n": "static-1.11127",
  "ui-addon-react-router-dom": "static-1.9519",
  "unified-auth": "static-1.461",
  "unified-auth-core-lib": "static-1.743",
  "usage-tracker": "static-1.7321",
  "usage-tracker-core": "static-1.7171",
  "customer-data-property-utils": "static-1.8063",
  "hub-http": "static-1.6197",
  "integrations-lib": "static-1.16024",
  "marketplace-ui-common": "static-1.19623",
  "property-management-iframe": "static-1.13051",
  "quartz-config": "static-1-hqd-quartz-routing-v2.22",
  "quartz-core": "static-1-hqd-quartz-routing-v2.22",
  "quartz-routing": "static-1-hqd-quartz-routing-v2.22",
  "quick-fetch": "static-1.3895",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4627",
  "ts-schema": "static-1.4059",
  "ui-universal-auth": "static-1.8947",
  "UIComponents": "static-3.8389",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3382",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1-hqd-quartz-routing-v2.22",
  "quartz-webpack": "static-1-hqd-quartz-routing-v2.22",
  "bend-plugin-quartz-routing": "static-1-hqd-quartz-routing-v2.21",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4151",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4839",
  "foundations-theming-specialty": "static-1.2110",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9403",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.15",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5323",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1784",
  "ui-fonts": "static-1.705",
  "ui-images": "static-2.1146",
  "bend-plugin-foundations-theming": "static-1.2877",
  "foundations-theming-base": "static-1.3379",
  "stylex": "static-1.32",
  "HeadJS": "static-2.751",
  "hs-test-utils-bend-plugin": "static-1.3100",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4302",
  "ai-components-ui-library": "static-1.8868",
  "ai-rendering-library": "static-1.10035",
  "chirp-fetch": "static-1.1862",
  "connections-embed-lib": "static-1.938",
  "copilot-toolkit": "static-1.11067",
  "feedback-loader": "static-1.29246",
  "laboratory-lib": "static-3.7134",
  "marketplace-embed": "static-1.22002",
  "marketplace-ui-details": "static-1.9519",
  "marketplace-ui-reviews": "static-1.19579",
  "marketplace-ui-tracking": "static-1.13794",
  "sanitize-text": "static-1.8118",
  "ui-addon-video-player": "static-1.8678",
  "usage-tracker-multi": "static-1.5735",
  "usage-tracker-session-replay": "static-1.5007",
  "wootric-nps": "static-1.6958",
  "quartz-head": "static-1-hqd-quartz-routing-v2.22",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4625",
  "immer": "static-1.33",
  "immerable": "static-1.4129",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2495",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "cssUtils": "static-1.785",
  "flux-actions": "static-1.331",
  "HubStyle": "static-2.11750",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10185",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10345",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7311",
  "icons": "static-2.644",
  "marketplace-ui-apps-core": "static-1.18156",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4491",
  "foundations-components-test-utils": "static-1.5365",
  "quartz-i18n": "static-1-hqd-quartz-routing-v2.22",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.154",
  "microsoft-drive-integration-lib": "static-1.271",
  "fsm": "static-1.3706",
  "customer-data-objects": "static-1.7638",
  "property-translator": "static-1.5376",
  "hs-locale-management": "static-1.64",
  "frontend-preferences-client": "static-1.7904",
  "hs-promise-utils": "static-1.5571",
  "hubspot-apollo-client": "static-1.4852",
  "integrations-error-boundary-lib": "static-1.13439",
  "integrations-tracking-lib": "static-1.5574",
  "native-integrations-shared-strings": "static-1.7758",
  "reselect": "static-2.16",
  "sanitize": "static-1.4453",
  "superstore": "static-1.4740",
  "ui-shepherd-react": "static-3.10132",
  "ai-settings-ui-library": "static-1.7843",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4631",
  "immutable-less": "static-1.4630",
  "marketplace-ui-client-types": "static-1.17030",
  "nav-meta": "static-1.29592",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10222",
  "ui-addon-upgrades": "static-9.17948",
  "inbound-db-properties-service-client": "static-1.3825",
  "property-management-common": "static-1.5339",
  "ui-addon-iframeable": "static-1.9032",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.526",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1-hqd-quartz-routing-v2.22",
  "quartz-test": "static-1-hqd-quartz-routing-v2.22",
  "quartz-tracking": "static-1-hqd-quartz-routing-v2.22",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.37",
  "bender-build-tools": "static-1.3171",
  "inbound-db-meta-service-client": "static-1.3569",
  "persist-promise": "static-1.3672",
  "reference-resolvers": "static-1.8144",
  "transmute": "static-2.85",
  "hubspotter-http-shared-msw-handlers": "static-1.9896",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21156",
  "ContentUtils": "static-1.68281",
  "customer-data-objects-ui-components": "static-1.13000",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2473",
  "customer-data-filters-ui": "static-1.39660",
  "customer-data-reference-ui-components": "static-1.13135",
  "embedded-academy-lib": "static-1.14256",
  "ExportDialog": "static-6.10367",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41231",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.88",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "ui-addon-teams": "static-1.21509",
  "magpie-lib": "static-1.5538",
  "navigation-components": "static-1.17955",
  "magpie-types": "static-1.4998",
  "simple-logging-lib": "static-1.3024",
  "ai-studio-lib": "static-1.11529",
  "app-governance-lib": "static-1.1456",
  "developer-experience-shared-components": "static-1.10485",
  "ui-addon-integrations-directory-panel": "static-2.7972",
  "ui-product-approvals": "static-1.28065",
  "ui-tool-access": "static-1.10125",
  "usage-based-billing-components-lib": "static-1.8756",
  "usage-tracker-anonymous": "static-1.5738",
  "usage-tracker-public": "static-1.7132",
  "amplitude-session-replay-browser": "static-1.59",
  "ui-extensibility-client-types": "static-1.3906",
  "hubspot-apollo-cache": "static-1.311",
  "universal-page-editor-lib": "static-1.2988",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2699",
  "merchandise-lib": "static-1.263",
  "atom": "static-1.5047",
  "purchase-motions-components": "static-1.5838",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1515",
  "crm-component-utils": "static-1.39003",
  "crm-properties-common-lib": "static-1.5857",
  "customer-data-properties": "static-1.51448",
  "framework-data-schema-resolvers": "static-1.6858",
  "property-value-citations": "static-1.2062",
  "reference-resolvers-lite": "static-1.8070",
  "navigation-messaging": "static-1.7282",
  "growth-payments-core": "static-1.25295",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13601",
  "conversations-skeleton-state": "static-1.7223",
  "crm-message-bus": "static-1.42917",
  "reporting-plugins": "static-1.10280",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.88",
  "cms-field-types": "static-1.4787",
  "content-icons-ui": "static-1.2219",
  "customer-data-ui-utilities": "static-1.9801",
  "customer-data-filters-ui-msw-helpers": "static-1.22095",
  "FormUrlGenerator": "static-2.4694",
  "framework-builder-read-service-client": "static-1.3988",
  "framework-data-schema-quick-fetch": "static-1.6763",
  "multi-account-reference-resolvers": "static-1.953",
  "onboarding-tours": "static-1.16548",
  "academy-common-lib": "static-1.13716",
  "content-assistance-lib": "static-1.7711",
  "dashboard-lib": "static-1.81413",
  "file-manager-components": "static-1.23545",
  "getting-started-shared-tasks": "static-1.18426",
  "hubspot-prosemirror": "static-1.18167",
  "hubspot-prosemirror-plugins": "static-1.18159",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19782",
  "share-with-third-party-component-lib": "static-1.8679",
  "ui-addon-draggable": "static-3.4743",
  "ui-asset-management-lib": "static-1.10988",
  "ui-business-units-lib": "static-1.9024",
  "user-context": "static-1.5078",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.697",
  "nest": "static-1.202",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10600",
  "framework-listing-lib": "static-2.28615",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30656",
  "apps-service-types": "static-1.3852",
  "oauth-service-types": "static-1.4225",
  "onboarding-scopes": "static-1.6437",
  "onboarding-tours-client": "static-1.4762",
  "platform-infra-nav-components": "static-1.7652",
  "subscription-experience-data-types": "static-1.14894",
  "crm-record-cards-service-types": "static-1.3587",
  "location-customization-utils-lib": "static-1.9168",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5841",
  "signup-constants": "static-1.18796",
  "signup-ui-url-generator": "static-2.8018",
  "trials-service-types": "static-1.3878",
  "card-properties-lib": "static-1.44095",
  "commerce-subscription-lib": "static-1.37029",
  "crm-actions": "static-1.6297",
  "crm-cards-sdk": "static-1.43501",
  "customer-data-properties-shared-msw-handlers": "static-1.9225",
  "customer-data-tracking": "static-1.6863",
  "hs-resources": "static-1.127",
  "pulse": "static-1.545",
  "calling-global-api": "static-1.64425",
  "calling-internal-common": "static-1.31277",
  "calling-lifecycle-internal": "static-1.65807",
  "calling-lifecycle-messages": "static-1.58101",
  "commerce-products-lib": "static-1.9457",
  "conditional-properties-service-client": "static-1.3776",
  "crm-links": "static-1.6260",
  "external-options-client-types": "static-1.4137",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4202",
  "meetings-icalendar-utils-lib": "static-1.607",
  "multi-currency-client-types": "static-1.3670",
  "object-builder-ui-client": "static-1.48643",
  "pipeline-validation-client-types": "static-1.3944",
  "smart-property-lib": "static-1.6786",
  "tiered-pricing": "static-1.1143",
  "ui-addon-form-validation": "static-1.10968",
  "crm-pipelines-api-client-types": "static-1.4121",
  "ui-addon-opt": "static-4.8347",
  "campaign-roi-lib": "static-1.9002",
  "react-dnd-compat": "static-1.4595",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5387",
  "growth-onboarding-confetti": "static-1.3042",
  "growth-onboarding-next-action-utils": "static-1.1842",
  "onboarding-tours-utils": "static-1.614",
  "ui-shepherd-tracker": "static-1.7513",
  "academy-service-client": "static-1.3657",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39044",
  "FileManagerLib": "static-1.39185",
  "video-embed": "static-1.35673",
  "zustand": "static-1.74",
  "ui-coaching-tips": "static-1.28473",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11181",
  "video-data-lib": "static-1.34839",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23458",
  "ui-addon-emoji-picker": "static-1.9864",
  "EmailSignatureEditor": "static-1.24310",
  "viral-links-lib": "static-1.7032",
  "data-token-picker": "static-1.16360",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.202",
  "timezone-utils": "static-2.5220",
  "getting-started-shared-tasks-store": "static-1.17544",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7300",
  "customer-data-views-management": "static-1.25398",
  "framework-data-table": "static-2.11850",
  "marketing-platform-lib": "static-1.6829",
  "nudge-client-utils": "static-1.2509",
  "nudge-custom-ui-functions": "static-1.985",
  "app-users-service-client": "static-1.5571",
  "app-users-service-types": "static-1.4979",
  "mini-checkout-client": "static-1.26733",
  "onboarding-utils": "static-1.5328",
  "permissions-shared-i18n-strings-fe": "static-1.2045",
  "ui-coaching-tips-shared-config": "static-1.28458",
  "edison-service-client-types": "static-1.362",
  "crm_data": "static-4.91877",
  "customer-data-sidebar": "static-2.45934",
  "enrichment-properties-lib": "static-1.15904",
  "commerce-billing-lib": "static-1.18987",
  "commerce-shared-components-lib": "static-1.18460",
  "commerce-tools-ui-lib": "static-1.10298",
  "crm-fe-perf": "static-1.22878",
  "bend-plugin-pulse": "static-1.48",
  "directed-graph": "static-1.910",
  "event-emitter": "static-1.923",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31284",
  "shared-worker-versioning": "static-1.11013",
  "calling-usage-tracker": "static-1.6518",
  "voice-sms-access-library": "static-1.868",
  "commerce-permissions": "static-1.742",
  "products-iframe-lib": "static-1.7856",
  "products-ui-components-shared-msw-handlers": "static-1.10280",
  "data-agent-kit": "static-1.152",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9981",
  "policy-lib": "static-1.6753",
  "react-tinymce": "static-1.55165",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10044",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54291",
  "tinymce-plugins": "static-1.57405",
  "tinymce-themes": "static-1.56261",
  "breeze-engine-lib": "static-1.532",
  "onboarding-data-sync-lib": "static-1.1916",
  "growth-onboarding-next-action-components": "static-1.1870",
  "user-context-client": "static-1.4587",
  "audio-components": "static-1.5876",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36696",
  "urlinator": "static-1.4512",
  "video-components": "static-1.13184",
  "outpost": "static-1.4160",
  "growth-onboarding-feedback-components": "static-1.6557",
  "content-media-composition-data-lib": "static-1.12168",
  "content-media-compositions": "static-2.16175",
  "media-bridge-lib": "static-1.18878",
  "commerce-tours-lib": "static-1.6044",
  "growth-onboarding-reliability": "static-1.5058",
  "sales-checkout-service-client": "static-1.3614",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21626",
  "sales-email-signature-service-client": "static-1.3818",
  "ts-utils-lib": "static-1.148",
  "crm-export-dialog": "static-1.6272",
  "crm-index-associations-lib": "static-1.6415",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1884",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2266",
  "nudge-renderer-utils": "static-1.2585",
  "whisper-core-api": "static-1.6541",
  "InboxConnectUtils": "static-4.14737",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5439",
  "settings-content-modals": "static-1.45998",
  "crm_universal": "static-1.21959",
  "customer-data-email": "static-1.17986",
  "card-payment-highlight-lib": "static-1.37086",
  "card-subscription-highlight-lib": "static-1.39452",
  "commerce-contract-lib": "static-1.11930",
  "invoices-highlight-card-lib": "static-1.54632",
  "orders-highlight-card-lib": "static-1.21394",
  "products-highlight-card-lib": "static-1.17740",
  "quotes-highlight-card-lib": "static-1.71919",
  "crm-source-interpretation-lib": "static-1.5316",
  "utility-belt": "static-1.2512",
  "payments-enrollment-embed-lib": "static-1.22699",
  "stripe-embedded-components": "static-1.7455",
  "customer-data-rte": "static-1.32921",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5669",
  "payments-post-enroll-local-storage-lib": "static-1.5084",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.38009",
  "calling-orchestration-schema": "static-1.35645",
  "sales-views-client-types": "static-1.4239",
  "hub-http-contrib": "static-1.3017",
  "interframe": "static-3.4736",
  "tinymce-data": "static-1.40376",
  "ui-addon-sales-email": "static-1.5186",
  "layout-dnd-components": "static-1.12394",
  "layout-dnd-utils": "static-1.11369",
  "ui-brand-identity-lib": "static-1.15153",
  "NamespacedHubStyle": "static-2.9040",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22006",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1888",
  "checkout-sdk": "static-3.23576",
  "checkout-service-types": "static-1.3805",
  "company-details-components": "static-1.6173",
  "payment-method-components": "static-1.6888",
  "pricing-pages-ui-components": "static-1.13836",
  "quote-checkout-service-types": "static-1.3452",
  "upgrade-catalog-service-types": "static-1.3501",
  "access-control-lib": "static-1.10412",
  "EmailComponents": "static-1.54698",
  "EmailData": "static-1.53375",
  "redux-less": "static-2.9458",
  "sequences-lib": "static-1.7993",
  "ui-gdpr-components": "static-1.10322",
  "products-ui-components": "static-1.39975",
  "accounting-integrations-ui-components": "static-1.7020",
  "invoices-ui-lib": "static-1.54648",
  "commerce-products-api": "static-1.2246",
  "invoices-iframe-lib": "static-1.56706",
  "quotes-modal-lib": "static-1.102597",
  "quotes-ui-lib": "static-1.80640",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28190",
  "ContentData": "static-1.68356",
  "layout-data-lib": "static-1.9694",
  "hub-http-rxjs": "static-1.796",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3913",
  "billing-payments-client-types": "static-1.3965",
  "react-performance-metrics-lib": "static-1.534",
  "account-and-billing-fintech-outages": "static-3.18548",
  "pricing-pages-api": "static-1.13701",
  "ContentComponents": "static-2.71237",
  "marketing-contacts-lib": "static-1.9915",
  "marketing-email-service-types": "static-1.1902",
  "messaging-editing-lib": "static-1.46188",
  "messaging-usage-based-billing-components-lib": "static-1.1050",
  "automation-ui-source-apps": "static-1.18794",
  "automation-ui-types": "static-1.19712",
  "messaging-types-lib": "static-1.45925",
  "onboarding-settings-client": "static-1.4478",
  "sequences-client-types-lib": "static-1.7850",
  "commerce-tax-lib": "static-1.501",
  "price-books-api": "static-1.565",
  "price-books-components": "static-1.623",
  "property-description-translator": "static-1.3821",
  "ramp-editor": "static-1.77",
  "commerce-analytics-service-client": "static-1.3602",
  "totals-ui-components": "static-1.23517",
  "SalesContentIndexUI": "static-3.9203",
  "advanced-menus-core": "static-1.15089",
  "advanced-menus-lib": "static-1.12034",
  "ui-memberships-settings-lib": "static-1.33970",
  "segments-query-core": "static-1.1394",
  "demographics-service-types": "static-1.1627",
  "eligibility-engine-service-types": "static-1.3159",
  "automation-ui-ubb": "static-1.5628",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7316",
  "data-token-views": "static-1.16341",
  "forms-utils-lib": "static-1.12527",
  "payments-embed-points-lib": "static-1.12975",
  "simple-menus-core": "static-1.15088",
  "simple-menus-lib": "static-1.16605",
  "ui-addon-draggable-compat": "static-2.4230",
  "videoconference-integration-components": "static-1.6780",
  "marketing-contacts-client": "static-1.7494",
  "automation-applications-service-types": "static-1.3479",
  "automation-platform-service-types": "static-1.2578",
  "ContentEditorUI": "static-2.77039",
  "short-messages-app-service-client": "static-1.3949",
  "web-interactives-components": "static-1.13713",
  "web-interactives-data": "static-1.13714",
  "messaging-shared-utils-lib": "static-1.499",
  "messaging-user-info-utils-lib": "static-1.669",
  "email-portal-health-service-types": "static-1.951",
  "line-items-api": "static-1.648",
  "commerce-totals-service-types": "static-1.3797",
  "FireAlarmUi": "static-1.4492",
  "sales-templates-service-types-lib": "static-1.4149",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21648",
  "automation-ui-usage-tracking": "static-1.21111",
  "data-studio-ubb": "static-1.2645",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26962",
  "collaboration-sidebar": "static-1.57717",
  "content-management-data-lib": "static-1.5351",
  "copilot-plugins": "static-1.11040",
  "cta-picker": "static-1.36328",
  "customer-agent-discovery-components-lib": "static-1.3010",
  "editor-components": "static-1.13193",
  "editor-iframe-lib": "static-1.8365",
  "error-messaging-js": "static-1.5167",
  "FormsCommonComponents": "static-1.85763",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10621",
  "SharedLegalStrings": "static-1.1723",
  "smart-content-core": "static-1.42362",
  "smart-content-lib": "static-1.43015",
  "social-composer-lib": "static-1.58985",
  "structured-content-lib": "static-1.25117",
  "theme-previewer-lib": "static-1.53175",
  "tinymce-copilot": "static-1.16359",
  "xray-recommendation-lib": "static-1.7862",
  "automation-ui-routing": "static-1.21069",
  "sql-reporting-client-types": "static-1.5615",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42136",
  "campaigns-utils-lib": "static-1.3154",
  "reporting-enablement": "static-1.22821",
  "chatspot-widget-iframe": "static-1.21147",
  "collaboration-sidebar-common": "static-1.2514",
  "forms-ai-lib": "static-1.4279",
  "codemirror-dlb": "static-1.58598",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6405",
  "report-customization-components": "static-1.13084",
  "data-quality-ui-library": "static-1.12912",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.269",
  "reporting-insights-lib": "static-1.1658"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12159",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "dashboard-client-types": "/dashboard-client-types/static-1.367",
  "data-fetching-client": "/data-fetching-client/static-1.9647",
  "foundations-components": "/foundations-components/static-1.7882",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.907",
  "foundations-theming": "/foundations-theming/static-1.4394",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7989",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9898",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11443",
  "I18n": "/I18n/static-7.1617",
  "jasmine-runner": "/jasmine-runner/static-1.6442",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12220",
  "quartz": "/quartz/static-1-hqd-quartz-routing-v2.22",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2834",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.88",
  "settings-ui-lib": "/settings-ui-lib/static-1.12496",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7084",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11127",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9519",
  "unified-auth": "/unified-auth/static-1.461",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.743",
  "usage-tracker": "/usage-tracker/static-1.7321",
  "usage-tracker-core": "/usage-tracker-core/static-1.7171",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8063",
  "hub-http": "/hub-http/static-1.6197",
  "integrations-lib": "/integrations-lib/static-1.16024",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19623",
  "property-management-iframe": "/property-management-iframe/static-1.13051",
  "quartz-config": "/quartz-config/static-1-hqd-quartz-routing-v2.22",
  "quartz-core": "/quartz-core/static-1-hqd-quartz-routing-v2.22",
  "quartz-routing": "/quartz-routing/static-1-hqd-quartz-routing-v2.22",
  "quick-fetch": "/quick-fetch/static-1.3895",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4627",
  "ts-schema": "/ts-schema/static-1.4059",
  "ui-universal-auth": "/ui-universal-auth/static-1.8947",
  "UIComponents": "/UIComponents/static-3.8389",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3382",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1-hqd-quartz-routing-v2.22",
  "quartz-webpack": "/quartz-webpack/static-1-hqd-quartz-routing-v2.22",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1-hqd-quartz-routing-v2.21",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4151",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4839",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2110",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9403",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.15",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5323",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1784",
  "ui-fonts": "/ui-fonts/static-1.705",
  "ui-images": "/ui-images/static-2.1146",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2877",
  "foundations-theming-base": "/foundations-theming-base/static-1.3379",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.751",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3100",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4302",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8868",
  "ai-rendering-library": "/ai-rendering-library/static-1.10035",
  "chirp-fetch": "/chirp-fetch/static-1.1862",
  "connections-embed-lib": "/connections-embed-lib/static-1.938",
  "copilot-toolkit": "/copilot-toolkit/static-1.11067",
  "feedback-loader": "/feedback-loader/static-1.29246",
  "laboratory-lib": "/laboratory-lib/static-3.7134",
  "marketplace-embed": "/marketplace-embed/static-1.22002",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9519",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19579",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13794",
  "sanitize-text": "/sanitize-text/static-1.8118",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8678",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5735",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5007",
  "wootric-nps": "/wootric-nps/static-1.6958",
  "quartz-head": "/quartz-head/static-1-hqd-quartz-routing-v2.22",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4625",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4129",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2495",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.88",
  "cssUtils": "/cssUtils/static-1.785",
  "flux-actions": "/flux-actions/static-1.331",
  "HubStyle": "/HubStyle/static-2.11750",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10185",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10345",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7311",
  "icons": "/icons/static-2.644",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18156",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4491",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5365",
  "quartz-i18n": "/quartz-i18n/static-1-hqd-quartz-routing-v2.22",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.154",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.271",
  "fsm": "/fsm/static-1.3706",
  "customer-data-objects": "/customer-data-objects/static-1.7638",
  "property-translator": "/property-translator/static-1.5376",
  "hs-locale-management": "/hs-locale-management/static-1.64",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7904",
  "hs-promise-utils": "/hs-promise-utils/static-1.5571",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4852",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13439",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5574",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7758",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4453",
  "superstore": "/superstore/static-1.4740",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10132",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7843",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4631",
  "immutable-less": "/immutable-less/static-1.4630",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17030",
  "nav-meta": "/nav-meta/static-1.29592",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10222",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17948",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3825",
  "property-management-common": "/property-management-common/static-1.5339",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9032",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.526",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1-hqd-quartz-routing-v2.22",
  "quartz-test": "/quartz-test/static-1-hqd-quartz-routing-v2.22",
  "quartz-tracking": "/quartz-tracking/static-1-hqd-quartz-routing-v2.22",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.37",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3569",
  "persist-promise": "/persist-promise/static-1.3672",
  "reference-resolvers": "/reference-resolvers/static-1.8144",
  "transmute": "/transmute/static-2.85",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9896",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21156",
  "ContentUtils": "/ContentUtils/static-1.68281",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13000",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2473",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39660",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13135",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14256",
  "ExportDialog": "/ExportDialog/static-6.10367",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41231",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.88",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.88",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.88",
  "ui-addon-teams": "/ui-addon-teams/static-1.21509",
  "magpie-lib": "/magpie-lib/static-1.5538",
  "navigation-components": "/navigation-components/static-1.17955",
  "magpie-types": "/magpie-types/static-1.4998",
  "simple-logging-lib": "/simple-logging-lib/static-1.3024",
  "ai-studio-lib": "/ai-studio-lib/static-1.11529",
  "app-governance-lib": "/app-governance-lib/static-1.1456",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10485",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7972",
  "ui-product-approvals": "/ui-product-approvals/static-1.28065",
  "ui-tool-access": "/ui-tool-access/static-1.10125",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8756",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5738",
  "usage-tracker-public": "/usage-tracker-public/static-1.7132",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3906",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.311",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2988",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2699",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "atom": "/atom/static-1.5047",
  "purchase-motions-components": "/purchase-motions-components/static-1.5838",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1515",
  "crm-component-utils": "/crm-component-utils/static-1.39003",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5857",
  "customer-data-properties": "/customer-data-properties/static-1.51448",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6858",
  "property-value-citations": "/property-value-citations/static-1.2062",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8070",
  "navigation-messaging": "/navigation-messaging/static-1.7282",
  "growth-payments-core": "/growth-payments-core/static-1.25295",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13601",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7223",
  "crm-message-bus": "/crm-message-bus/static-1.42917",
  "reporting-plugins": "/reporting-plugins/static-1.10280",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.88",
  "cms-field-types": "/cms-field-types/static-1.4787",
  "content-icons-ui": "/content-icons-ui/static-1.2219",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9801",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22095",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4694",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3988",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6763",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.953",
  "onboarding-tours": "/onboarding-tours/static-1.16548",
  "academy-common-lib": "/academy-common-lib/static-1.13716",
  "content-assistance-lib": "/content-assistance-lib/static-1.7711",
  "dashboard-lib": "/dashboard-lib/static-1.81413",
  "file-manager-components": "/file-manager-components/static-1.23545",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18426",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18167",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18159",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19782",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8679",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4743",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10988",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9024",
  "user-context": "/user-context/static-1.5078",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.697",
  "nest": "/nest/static-1.202",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10600",
  "framework-listing-lib": "/framework-listing-lib/static-2.28615",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30656",
  "apps-service-types": "/apps-service-types/static-1.3852",
  "oauth-service-types": "/oauth-service-types/static-1.4225",
  "onboarding-scopes": "/onboarding-scopes/static-1.6437",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4762",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7652",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14894",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9168",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5841",
  "signup-constants": "/signup-constants/static-1.18796",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8018",
  "trials-service-types": "/trials-service-types/static-1.3878",
  "card-properties-lib": "/card-properties-lib/static-1.44095",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37029",
  "crm-actions": "/crm-actions/static-1.6297",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43501",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9225",
  "customer-data-tracking": "/customer-data-tracking/static-1.6863",
  "hs-resources": "/hs-resources/static-1.127",
  "pulse": "/pulse/static-1.545",
  "calling-global-api": "/calling-global-api/static-1.64425",
  "calling-internal-common": "/calling-internal-common/static-1.31277",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65807",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58101",
  "commerce-products-lib": "/commerce-products-lib/static-1.9457",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3776",
  "crm-links": "/crm-links/static-1.6260",
  "external-options-client-types": "/external-options-client-types/static-1.4137",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4202",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.607",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3670",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48643",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3944",
  "smart-property-lib": "/smart-property-lib/static-1.6786",
  "tiered-pricing": "/tiered-pricing/static-1.1143",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10968",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4121",
  "ui-addon-opt": "/ui-addon-opt/static-4.8347",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9002",
  "react-dnd-compat": "/react-dnd-compat/static-1.4595",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5387",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3042",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1842",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.614",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7513",
  "academy-service-client": "/academy-service-client/static-1.3657",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39044",
  "FileManagerLib": "/FileManagerLib/static-1.39185",
  "video-embed": "/video-embed/static-1.35673",
  "zustand": "/zustand/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28473",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11181",
  "video-data-lib": "/video-data-lib/static-1.34839",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23458",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9864",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24310",
  "viral-links-lib": "/viral-links-lib/static-1.7032",
  "data-token-picker": "/data-token-picker/static-1.16360",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.202",
  "timezone-utils": "/timezone-utils/static-2.5220",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17544",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7300",
  "customer-data-views-management": "/customer-data-views-management/static-1.25398",
  "framework-data-table": "/framework-data-table/static-2.11850",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6829",
  "nudge-client-utils": "/nudge-client-utils/static-1.2509",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.985",
  "app-users-service-client": "/app-users-service-client/static-1.5571",
  "app-users-service-types": "/app-users-service-types/static-1.4979",
  "mini-checkout-client": "/mini-checkout-client/static-1.26733",
  "onboarding-utils": "/onboarding-utils/static-1.5328",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2045",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28458",
  "edison-service-client-types": "/edison-service-client-types/static-1.362",
  "crm_data": "/crm_data/static-4.91877",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45934",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15904",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18987",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18460",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10298",
  "crm-fe-perf": "/crm-fe-perf/static-1.22878",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.48",
  "directed-graph": "/directed-graph/static-1.910",
  "event-emitter": "/event-emitter/static-1.923",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31284",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11013",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6518",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.868",
  "commerce-permissions": "/commerce-permissions/static-1.742",
  "products-iframe-lib": "/products-iframe-lib/static-1.7856",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10280",
  "data-agent-kit": "/data-agent-kit/static-1.152",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9981",
  "policy-lib": "/policy-lib/static-1.6753",
  "react-tinymce": "/react-tinymce/static-1.55165",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10044",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54291",
  "tinymce-plugins": "/tinymce-plugins/static-1.57405",
  "tinymce-themes": "/tinymce-themes/static-1.56261",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.532",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1916",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1870",
  "user-context-client": "/user-context-client/static-1.4587",
  "audio-components": "/audio-components/static-1.5876",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36696",
  "urlinator": "/urlinator/static-1.4512",
  "video-components": "/video-components/static-1.13184",
  "outpost": "/outpost/static-1.4160",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6557",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12168",
  "content-media-compositions": "/content-media-compositions/static-2.16175",
  "media-bridge-lib": "/media-bridge-lib/static-1.18878",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6044",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5058",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3614",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21626",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3818",
  "ts-utils-lib": "/ts-utils-lib/static-1.148",
  "crm-export-dialog": "/crm-export-dialog/static-1.6272",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6415",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1884",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2266",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2585",
  "whisper-core-api": "/whisper-core-api/static-1.6541",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14737",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5439",
  "settings-content-modals": "/settings-content-modals/static-1.45998",
  "crm_universal": "/crm_universal/static-1.21959",
  "customer-data-email": "/customer-data-email/static-1.17986",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37086",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39452",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11930",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54632",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21394",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17740",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71919",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5316",
  "utility-belt": "/utility-belt/static-1.2512",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22699",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7455",
  "customer-data-rte": "/customer-data-rte/static-1.32921",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5669",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5084",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.38009",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35645",
  "sales-views-client-types": "/sales-views-client-types/static-1.4239",
  "hub-http-contrib": "/hub-http-contrib/static-1.3017",
  "interframe": "/interframe/static-3.4736",
  "tinymce-data": "/tinymce-data/static-1.40376",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5186",
  "layout-dnd-components": "/layout-dnd-components/static-1.12394",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11369",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15153",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9040",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1888",
  "checkout-sdk": "/checkout-sdk/static-3.23576",
  "checkout-service-types": "/checkout-service-types/static-1.3805",
  "company-details-components": "/company-details-components/static-1.6173",
  "payment-method-components": "/payment-method-components/static-1.6888",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13836",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3452",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3501",
  "access-control-lib": "/access-control-lib/static-1.10412",
  "EmailComponents": "/EmailComponents/static-1.54698",
  "EmailData": "/EmailData/static-1.53375",
  "redux-less": "/redux-less/static-2.9458",
  "sequences-lib": "/sequences-lib/static-1.7993",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10322",
  "products-ui-components": "/products-ui-components/static-1.39975",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7020",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54648",
  "commerce-products-api": "/commerce-products-api/static-1.2246",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56706",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102597",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80640",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28190",
  "ContentData": "/ContentData/static-1.68356",
  "layout-data-lib": "/layout-data-lib/static-1.9694",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.796",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3913",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3965",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.534",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18548",
  "pricing-pages-api": "/pricing-pages-api/static-1.13701",
  "ContentComponents": "/ContentComponents/static-2.71237",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9915",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1902",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46188",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1050",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18794",
  "automation-ui-types": "/automation-ui-types/static-1.19712",
  "messaging-types-lib": "/messaging-types-lib/static-1.45925",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4478",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7850",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.501",
  "price-books-api": "/price-books-api/static-1.565",
  "price-books-components": "/price-books-components/static-1.623",
  "property-description-translator": "/property-description-translator/static-1.3821",
  "ramp-editor": "/ramp-editor/static-1.77",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3602",
  "totals-ui-components": "/totals-ui-components/static-1.23517",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9203",
  "advanced-menus-core": "/advanced-menus-core/static-1.15089",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12034",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33970",
  "segments-query-core": "/segments-query-core/static-1.1394",
  "demographics-service-types": "/demographics-service-types/static-1.1627",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3159",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5628",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7316",
  "data-token-views": "/data-token-views/static-1.16341",
  "forms-utils-lib": "/forms-utils-lib/static-1.12527",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12975",
  "simple-menus-core": "/simple-menus-core/static-1.15088",
  "simple-menus-lib": "/simple-menus-lib/static-1.16605",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4230",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6780",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7494",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3479",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2578",
  "ContentEditorUI": "/ContentEditorUI/static-2.77039",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3949",
  "web-interactives-components": "/web-interactives-components/static-1.13713",
  "web-interactives-data": "/web-interactives-data/static-1.13714",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.499",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.669",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.951",
  "line-items-api": "/line-items-api/static-1.648",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3797",
  "FireAlarmUi": "/FireAlarmUi/static-1.4492",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4149",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21648",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21111",
  "data-studio-ubb": "/data-studio-ubb/static-1.2645",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26962",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57717",
  "content-management-data-lib": "/content-management-data-lib/static-1.5351",
  "copilot-plugins": "/copilot-plugins/static-1.11040",
  "cta-picker": "/cta-picker/static-1.36328",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3010",
  "editor-components": "/editor-components/static-1.13193",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8365",
  "error-messaging-js": "/error-messaging-js/static-1.5167",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85763",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10621",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1723",
  "smart-content-core": "/smart-content-core/static-1.42362",
  "smart-content-lib": "/smart-content-lib/static-1.43015",
  "social-composer-lib": "/social-composer-lib/static-1.58985",
  "structured-content-lib": "/structured-content-lib/static-1.25117",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53175",
  "tinymce-copilot": "/tinymce-copilot/static-1.16359",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7862",
  "automation-ui-routing": "/automation-ui-routing/static-1.21069",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5615",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42136",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3154",
  "reporting-enablement": "/reporting-enablement/static-1.22821",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21147",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2514",
  "forms-ai-lib": "/forms-ai-lib/static-1.4279",
  "codemirror-dlb": "/codemirror-dlb/static-1.58598",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6405",
  "report-customization-components": "/report-customization-components/static-1.13084",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12912",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.269",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1658"
}
};
